module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "data-list-heading"
  }, [_c('div', {
    staticClass: "data-list-statusbar"
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.categories.length) + " subcategories\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "data-list-add",
    class: [{
      'data-list-add__close': _vm.addFormDisplay
    }],
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayAddForm()
      }
    }
  }, [_vm._v("Add new category")])]), _vm._v(" "), (_vm.parent) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.updatedCategories.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_c('button', {
    class: {
      'hover-filter-element': _vm.isExist(this.parent)
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeSelectedFilters,
      "mouseover": function($event) {
        return _vm.addHoverElement([{
          label: _vm.parent.label,
          value: _vm.parent.value
        }])
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.parent.label))])]), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])])]) : _vm._e(), _vm._v(" "), (_vm.addFormDisplay) ? _c('div', {
    staticClass: "categories-add-form"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-name"
    }
  }, [_vm._v("Category Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.title),
      expression: "newCategory.title"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-name"
    },
    domProps: {
      "value": (_vm.newCategory.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "input-category-icon"
    }
  }, [_vm._v("Category Icon")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.icon),
      expression: "newCategory.icon"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "id": "input-category-icon"
    },
    domProps: {
      "value": (_vm.newCategory.icon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "icon", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "select-parent-category"
    }
  }, [_vm._v("Parent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "name": "Category",
      "options": _vm.parentCategoriesForSelect,
      "id": "select-parent-category"
    },
    model: {
      value: (_vm.newCategory.parent),
      callback: function($$v) {
        _vm.$set(_vm.newCategory, "parent", $$v)
      },
      expression: "newCategory.parent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory.description),
      expression: "newCategory.description"
    }],
    staticClass: "form-control form-control__textarea",
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "name": "category-desc",
      "id": "textarea-category-desc",
      "cols": "30",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.newCategory.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCategory, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('a', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeAddForm()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCategory()
      }
    }
  }, [_vm._v("Create category")])]), _vm._v(" "), _c('hr', {
    staticClass: "add-form-delimiter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    staticClass: "categories-list-body__head"
  }, [_c('tr', [_c('th', {
    staticClass: "cellpadding categories-list-body__head_id table-head-ceil"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-search-col text-left categories-list-body__head_search table-head-ceil"
  }, [_c('div', {
    staticClass: "table-search-wrap"
  }, [_c('div', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "table-search",
    attrs: {
      "type": "search",
      "placeholder": "Category name..."
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-search-icon"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-body__head_parent-select table-head-ceil table-head-hover",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCategoriesForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCategoriesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "name": "Category",
      "data-vv-as": "\"Category\"",
      "options": _vm.getCategoriesForSelect,
      "placeholder": "Parent"
    },
    model: {
      value: (_vm.parent),
      callback: function($$v) {
        _vm.parent = $$v
      },
      expression: "parent"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "categories-list-body__head_count-articles table-head-ceil"
  }, [_vm._v("\n            No of articles\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "cellpadding categories-list-body__head_actions table-head-ceil",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "categories-list-body__body"
  }, _vm._l((_vm.updatedCategories), function(category, i) {
    return _c('tr', [(category.type === 'show') ? _c('td', {
      staticClass: "text-center cellpadding"
    }, [_vm._v("\n            " + _vm._s(category.id) + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v("\n            " + _vm._s(category.isChild ? '- ' + category.title : category.title) + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(category.parent ? category.parent.label : '-') + "\n          ")]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding"
    }, [_vm._v(_vm._s(category.contents.length))]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m edit-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showEditionForm(category.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), (category.type === 'show') ? _c('td', {
      staticClass: "cellpadding text-center"
    }, [_c('button', {
      staticClass: "table-crud-btn icon-btn-m delete-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeCategory(category.id)
        }
      }
    }, [_c('span', {
      staticClass: "table-tooltip"
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (category.type === 'edit') ? _c('td', {
      staticClass: "edit-row",
      attrs: {
        "colspan": "6"
      }
    }, [_c('div', {
      staticClass: "wrap-edit-form"
    }, [_c('div', {
      staticClass: "row-edit-form"
    }, [_c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.title),
        expression: "category.title"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (category.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-parent-select"
    }, [_c('v-select', {
      staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
      attrs: {
        "name": "Category",
        "options": _vm.getCategoriesForSelect,
        "searchable": false,
        "placeholder": "Parent"
      },
      model: {
        value: (category.parent),
        callback: function($$v) {
          _vm.$set(category, "parent", $$v)
        },
        expression: "category.parent"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "wrap-title-input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.icon),
        expression: "category.icon"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "placeholder": "Icon"
      },
      domProps: {
        "value": (category.icon)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "icon", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrap-desc-textarea"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (category.description),
        expression: "category.description"
      }],
      staticClass: "form-control form-control__textarea",
      attrs: {
        "name": "desc-textarea",
        "cols": "10",
        "rows": "1",
        "placeholder": "Description"
      },
      domProps: {
        "value": (category.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(category, "description", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "wrap-table-control-panel"
    }, [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.discardСhanges(category.id)
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editCategory(category.id)
        }
      }
    }, [_vm._v("Save")])])])]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Categories in \"Topics\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "textarea-category-desc"
    }
  }, [_vm._v("Category description\n            "), _c('span', [_vm._v("(will not show up in articles)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Type")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23508b2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CategoriesList.vue
// module id = 955
// module chunks = 0